export default __webpack_public_path__ + "b19f8946aa085ea7e2a79e54787a7609.png";